import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getImagingUltrasoundSelector } from '../selectors'
import { setAddToTimeLine } from '../store/ImagingUltrasound.actions'
import { ImagingUltrasoundConstants } from '../store/imagingUltrasound.constants'
import { IImagingUltrasoundState } from '../store/ImagingUltrasound.types'
import { addImagingUltrasoundItem } from '../../../timeline/store/timeline.actions'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'

export function* saveImagingUltrasound() {
  let imagingUltrasoundState: IImagingUltrasoundState = yield select(getImagingUltrasoundSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    imagingUltrasoundState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: imagingUltrasoundState,
      actionField: null,
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    imagingUltrasoundState = handleNemsisCodeError(error, imagingUltrasoundState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.imagingUltrasoundStateList && pcrDoc.patient?.imagingUltrasoundStateList.length) {
    const index = pcrDoc.patient?.imagingUltrasoundStateList?.findIndex(
      (imagingUltrasound) => imagingUltrasound.key === imagingUltrasoundState.key
    )
    if (index !== -1) {
      pcrDoc.patient.imagingUltrasoundStateList[index] = imagingUltrasoundState
    } else {
      pcrDoc.patient?.imagingUltrasoundStateList.push(imagingUltrasoundState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, imagingUltrasoundStateList: [imagingUltrasoundState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addImagingUltrasoundItem())
  } catch (e) {
    yield put(throwPcrException(`saveImageUltrasound() error: ${e}`))
  }
}

export function* saveImagingUltrasoundSaga() {
  yield takeLatest(
    [
      ImagingUltrasoundConstants.SAVE_IMAGING_ULTRASOUND,
      ImagingUltrasoundConstants.SET_DATE,
      ImagingUltrasoundConstants.SET_TIME,
      ImagingUltrasoundConstants.SET_RESPONSE,
      ImagingUltrasoundConstants.SET_RESPONSE_PNNV,
      ImagingUltrasoundConstants.SET_DATE_TIME,
      ImagingUltrasoundConstants.SET_ASSESSED_BY,
      ImagingUltrasoundConstants.SET_PROCEDURE_COMPLICATIONS,
      ImagingUltrasoundConstants.SET_AUTHORIZATION,
      ImagingUltrasoundConstants.SET_ROLE_PERFORMING,
      ImagingUltrasoundConstants.SET_ROLE_PERFORMING_PNNV,
      ImagingUltrasoundConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      ImagingUltrasoundConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      ImagingUltrasoundConstants.SET_LOCATION,
      ImagingUltrasoundConstants.SET_FINDINGS,
      ImagingUltrasoundConstants.SET_TYPE,
      ImagingUltrasoundConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveImagingUltrasound
  )
}
